import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button, Modal, Img } from "arv-reactcomponents";
import { Endpoints, Loyalty } from "npmlinks-constants";
import LoyaltyPointsPopUpBlock from "../LoyaltyPointsPopUpBlock";
import PropTypes from "prop-types";

@inject("OrderConfirmationStore")
@observer
class LoyaltyBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoyaltyInfoBlock: false,
    };

    this.showLoyaltyInfo = this.showLoyaltyInfo.bind(this);
  }

  showLoyaltyInfo(bool) {
    this.setState({
      showLoyaltyInfoBlock: bool,
    });
  }

  render() {
    const { showLoyaltyInfoBlock } = this.state;
    const { loyaltyPointsData } = this.props;
    const image = Endpoints.LOYALTY_GIFT_IMAGE;

    return (
      <div>
        <div className="nw-loyaltyblock-container">
          {image ? (
            <div className="nw-loyaltyblock-imagewrap">
              <Img className="nw-loyaltyblock-image" src={image} />
            </div>
          ) : null}
          <div className="nw-loyaltyblock-loyaltytext">
            <span className="nw-loyaltyblock-loyaltytext1">
              {Loyalty.LOYALTY_EARN_POINTS_TEXT}
            </span>
            <span className="nw-loyaltyblock-loyaltytext2">
              {Loyalty.LOYALTY_REDEEM_POINTS_TEXT}
              <Button
                className="nwc-btn-primary-txt nwc-btn-normal nw-loyaltyblock-loyaltyinfolink"
                onClick={() => {
                  this.showLoyaltyInfo(true);
                }}
              >
                {Loyalty.LOYALTY_POINTS_LINK_TEXT}
              </Button>
            </span>
          </div>
        </div>
        <Modal
          className="nw-modal"
          isOpen={showLoyaltyInfoBlock}
          onClose={() => {
            this.showLoyaltyInfo(false);
          }}
        >
          <LoyaltyPointsPopUpBlock.component
            loyaltyPointsData={loyaltyPointsData}
          />
        </Modal>
      </div>
    );
  }
}

LoyaltyBlock.propTypes = {
  loyaltyPointsData: PropTypes.array.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: LoyaltyBlock,
  component: LoyaltyBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/LoyaltyBlock/index.js